/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostUsersForgotPasswordVerifyMutationRequest, PostUsersForgotPasswordVerifyMutationResponse, PostUsersForgotPasswordVerify400 } from "../entities/PostUsersForgotPasswordVerify";

function getPostUsersForgotPasswordVerifyUrl() {
  const res = { method: 'POST', url: `/users/forgot-password/verify` as const }  
  return res
}

/**
 * @description Подтверждение восстановления пароля
 * @summary Подтверждение
 * {@link /users/forgot-password/verify}
 */
export async function postUsersForgotPasswordVerify(data: PostUsersForgotPasswordVerifyMutationRequest, config: Partial<RequestConfig<PostUsersForgotPasswordVerifyMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PostUsersForgotPasswordVerifyMutationResponse, ResponseErrorConfig<PostUsersForgotPasswordVerify400>, PostUsersForgotPasswordVerifyMutationRequest>({ method : "POST", url : getPostUsersForgotPasswordVerifyUrl().url.toString(), data : requestData, ... requestConfig })  
  return res.data
}